var map = {
	"./books.svg": "cd6f",
	"./building.svg": "d439",
	"./chart.svg": "3653",
	"./checkbox.svg": "eca4",
	"./chevron.svg": "3e50",
	"./expanded-icon.svg": "6db6",
	"./filter.svg": "bcee",
	"./grid.svg": "14a4",
	"./list.svg": "484a",
	"./logout.svg": "a861",
	"./mail.svg": "4f1b",
	"./news-icon.svg": "4de9",
	"./settings.svg": "bc64",
	"./star.svg": "ec6f",
	"./starC.svg": "67b7",
	"./support.svg": "b0d4",
	"./table-document-icon.svg": "7dfa",
	"./user-settings.svg": "bd20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";